import { ZxcvbnFactory } from "@zxcvbn-ts/core";
import * as zxcvbnCommonPackage from "@zxcvbn-ts/language-common";
import * as zxcvbnEnPackage from "@zxcvbn-ts/language-en";
import sha1 from "crypto-js/sha1";
import axios from "axios";
import { env } from "./env";

const zxcvbn = new ZxcvbnFactory({
  translations: zxcvbnEnPackage.translations,
  graphs: zxcvbnCommonPackage.adjacencyGraphs,
  dictionary: {
    ...zxcvbnCommonPackage.dictionary,
    ...zxcvbnEnPackage.dictionary,
  },
});

export const hasUpperCase = (value: string) => /[A-Z]/.test(value);
export const hasLowercase = (value: string) => /[a-z]/.test(value);
export const hasDigit = (value: string) => /[0-9]/.test(value);
export const hasSymbol = (value: string) => /[!@#%&]/.test(value);

// Zxcvbn strength threshold
const MIN_SCORE = 3;
export const checkZxcvbnStrength = (value: string) => {
  const result = zxcvbn.check(value);
  return result.score >= MIN_SCORE;
};

export const checkHIBP = async (value: string) => {
  const sha1Hash = sha1(value).toString().toUpperCase();
  const prefix = sha1Hash.slice(0, 5);
  const suffix = sha1Hash.slice(5);

  const res = await axios.get(`${env.passwordCheckUrl}${prefix}`);
  return !res.data.includes(suffix); // true if NOT found
};
